module.exports = __webpack_public_path__ + "img/send-message_liveflamingo.3b0bbf1c.svg";